import type { UploadPhase } from '@/features/uploads/types/uploads';

/** Phases that need no further byte/status work. */
export const TERMINAL_UPLOAD_PHASES: ReadonlySet<UploadPhase> = new Set<UploadPhase>([
  'blocked-duplicate',
  'blocked-near-duplicate',
  'accepted',
  'rejected-duplicate',
  'rejected-quality',
  'failed',
  'cancelled',
]);
